import React, { Component } from 'react';
import moment from 'moment';
import { Badge } from 'react-bootstrap';
import { connect } from 'shalala';

import { Event } from '../../../support';
import { useStore } from '../../../store';
import EmisorStatus from '../enum/EmisorStatus';
import Table from '../../../facturotopia/table/Table';
import {
  EmisoresListSectorPrimarioColumn,
  EmisoresListSectorPrimarioRoleColumn,
} from './components/EmisoresListSectorPrimarioColumns';

import { Guardian } from '@xaamin/guardian';

const renderStatus = (item) => {
  const { status: actualStatus } = item;

  let text = 'pending';
  let variant = 'info';

  const status = EmisorStatus.search(actualStatus) || EmisorStatus.undefined();

  switch (true) {
    case status.isActive():
      text = 'active';
      variant = 'success';
      break;

    case status.isInvited():
      text = 'invited';
      break;

    case status.isBlocked():
      text = 'blocked';
      variant = 'danger';
      break;

    default:
      break;
  }

  return <Badge variant={variant}>{text}</Badge>;
};

class EmisoresList extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      columns: this.columns,
      selected: [],
    };

    Event.on('app.refresh', this.handleOnAppNeedsRefresh);
  }

  get columns() {
    const sectorPrimarioColumns = Guardian.allows('sector_primario.access')
      ? [
          {
            key: 'sector_primario',
            title: 'Sector primario',
            dataIndex: 'sector_primario',
            align: 'center',
            render: (item) => <EmisoresListSectorPrimarioColumn data={item} />,
          },
          {
            key: 'sector_primario_is_productor',
            title: 'Rol',
            dataIndex: 'sector_primario_is_productor',
            align: 'center',
            render: (item) => <EmisoresListSectorPrimarioRoleColumn data={item} />,
          },
        ]
      : [];

    const common = [
      {
        key: 'rfc',
        title: 'RFC',
        dataIndex: 'rfc',
      },
      {
        key: 'razon_social',
        title: 'Razón Social',
        dataIndex: 'razon_social',
      },
      {
        key: 'regimen',
        title: 'Régimen',
        dataIndex: 'regimen',
      },
      {
        key: 'expira_at',
        title: 'Fecha expiración',
        dataIndex: 'expira_at',
      },
      {
        key: 'grupo',
        title: 'Grupo',
        dataIndex: 'grupo',
      },
    ];

    return [
      ...common,
      ...sectorPrimarioColumns,
      {
        key: 'status',
        title: 'Status',
        dataIndex: 'status',
        render: renderStatus,
      },
    ];
  }

  componentDidMount() {
    const { data } = this.props.list;

    if (data.length === 0) {
      this.paginate(1);
    }
  }

  componentWillUnmount() {
    Event.off('app.refresh', this.handleOnAppNeedsRefresh);
  }

  async paginate(meta) {
    const { filters = {} } = this.props.list;

    await this.props.paginate({
      ...filters,
      ...meta,
    });
  }

  handleOnAppNeedsRefresh = () => {
    this.paginate({ page: 1 });
  };

  handleOnPageChange = (page) => {
    this.paginate({ page });
  };

  handleOnPageLimitChange = (limit) => {
    this.paginate({ limit, page: 1 });
  };

  handleRowSelectionChange = ({ selectedRowKeys, selectedRows }) => {
    this.setState(
      {
        selected: selectedRowKeys,
      },
      () => {
        const { onRowSelectionChange } = this.props;

        onRowSelectionChange && onRowSelectionChange({ selectedRowKeys, selectedRows });
      }
    );
  };

  getRowSelectionConfig = () => {
    return {
      type: 'checkbox',
      onChange: this.handleRowSelectionChange,
      getCheckboxProps: (record) => ({
        disabled: record.name === 'Disabled User', // Column uration not to be checked
        name: record.name,
      }),
    };
  };

  getPaginationConfig() {
    const { pagination } = this.props.list;

    return {
      metadata: pagination,
      onPageChange: this.handleOnPageChange,
      onPageLimitChange: this.handleOnPageLimitChange,
    };
  }

  getListHighlight() {
    const { data = [] } = this.props.list;

    return data.map((item) => {
      const days = moment(item.expira_at).diff(moment(), 'days');

      return days <= 15 ? { ...item, highlight: true } : { ...item };
    });
  }

  render() {
    const { columns, selected } = this.state;
    const { onRowClick, list } = this.props;

    return (
      <Table
        loading={list.busy}
        columns={columns}
        rowKey={'id'}
        data={this.getListHighlight()}
        pagination={this.getPaginationConfig()}
        rowSelection={{
          selectedRowKeys: selected,
          ...this.getRowSelectionConfig(),
        }}
        onRowClick={onRowClick}
        onRow={(item) => {
          return {
            className: item.highlight ? 'row-highlighted' : '',
          };
        }}
      ></Table>
    );
  }
}

const mapState = (store) => {
  return { list: store.app.emisores.list };
};

const mapActions = (actions) => {
  return actions.app.emisores.list;
};

export default connect(useStore, mapState, mapActions)(EmisoresList);
